import { Reducer } from 'redux';
import {
    ActionTypes,
    GET_APIUSERS_REQUEST, GET_APIUSERS_SUCCESS, GET_APIUSERS_FAILURE,
    GET_APIUSER_REQUEST, GET_APIUSER_SUCCESS, GET_APIUSER_FAILURE,
    ADD_APIUSER_REQUEST, ADD_APIUSER_SUCCESS, ADD_APIUSER_FAILURE,
    EDIT_APIUSER_REQUEST, EDIT_APIUSER_SUCCESS, EDIT_APIUSER_FAILURE,
    DELETE_APIUSER_REQUEST, DELETE_APIUSER_SUCCESS, DELETE_APIUSER_FAILURE,
    SET_ADD_APIUSER_POPUP, SET_EDIT_APIUSER_POPUP, SET_DELETE_APIUSER_POPUP,
    RESET_APIUSER_STATE
} from '../actions/apiUsers.action';


export interface User {
    uuid: string;
    firstName: string;
    lastName: string;
    email: string;
    companyUuid: string;
}

export interface State {
    apiUsers: User[];
    apiUser: User | {};
    loading: boolean;
    error: string | null;
    addUserLoading: boolean;
    editUserLoading: boolean;
    deleteUserLoading: boolean;
    addPopupOpen: boolean;
    editPopupOpen: boolean;
    deletePopupOpen: boolean;

}

const initialState: State = {
    apiUsers: [],
    apiUser: {},
    loading: false,
    addUserLoading: false,
    editUserLoading: false,
    deleteUserLoading: false,
    error: null,
    addPopupOpen: false,
    editPopupOpen: false,
    deletePopupOpen: false,
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case GET_APIUSERS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_APIUSERS_SUCCESS:
            return { ...state, apiUsers: action.payload, loading: false, error: null };
        case GET_APIUSERS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        // case GET_APIUSER_REQUEST:
        //     return { ...state, loading: true, error: null };
        // case GET_APIUSER_SUCCESS:
        //     return { ...state, user: action.payload, loading: false, error: null };
        // case GET_APIUSER_FAILURE:
        //     return { ...state, loading: false, error: action.payload };
        case ADD_APIUSER_REQUEST:
            return { ...state, addUserLoading: true };
        case ADD_APIUSER_SUCCESS:
            return { ...state, addUserLoading: false };
        case ADD_APIUSER_FAILURE:
            return { ...state, addUserLoading: false };
        case EDIT_APIUSER_REQUEST:
            return { ...state, editUserLoading: true };
        case EDIT_APIUSER_SUCCESS:
            return { ...state, editUserLoading: false };
        case EDIT_APIUSER_FAILURE:
            return { ...state, editUserLoading: false };
        case DELETE_APIUSER_REQUEST:
            return { ...state, deleteUserLoading: true };
        case DELETE_APIUSER_SUCCESS:
            return { ...state, deleteUserLoading: false };
        case DELETE_APIUSER_FAILURE:
            return { ...state, deleteUserLoading: false };
        case SET_ADD_APIUSER_POPUP:
            return { ...state, addPopupOpen: action.payload };
        case SET_EDIT_APIUSER_POPUP:
            return { ...state, editPopupOpen: action.payload };
        case SET_DELETE_APIUSER_POPUP:
            return { ...state, deletePopupOpen: action.payload };
        case RESET_APIUSER_STATE:
            return {...initialState}
        default:
            return state;
    }
};

export default reducer;
